import { createContext } from "react";

const SiteContext = createContext()

export default SiteContext;